import React from 'react';

/**
 * GraficoBarras — comparação de valores. A lista visível é o dado; a barra só reforça.
 * itens: [{ rotulo, valor }]. formatar(valor) devolve o texto (ex.: R$ 48.750,00).
 */
export default function GraficoBarras({ itens, formatar = (v) => String(v), rotulo = 'Gráfico' }) {
  const maximo = Math.max(...itens.map((i) => i.valor), 0) || 1;
  return (
    <div className="sj-barras" role="list" aria-label={rotulo}>
      {itens.map((i) => (
        <div key={i.rotulo} className="sj-barra-item" role="listitem">
          <span>{i.rotulo}</span>
          <div className="sj-barra-item__trilho">
            <div className="sj-barra-item__valor" style={{ width: `${(i.valor / maximo) * 100}%` }} />
          </div>
          <span className="sj-barra-item__numero sj-num">{formatar(i.valor)}</span>
        </div>
      ))}
    </div>
  );
}
